<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
               

      <h1 class="title center__text">ENVOI SMS IMMOBILIER</h1>
      <img class="card__image" src="/../images/immoble.png" alt="" />
      <h2>
        Le SMS professionnel est largement utilisé dans le secteur immobilier
      </h2>
      <p>
        Le secteur de l'immobilier requiert réactivité et communication. Les agences immobilières, nombreuses sur le marché, cherchent 
        à se démarquer en utilisant des canaux de communication originaux et efficaces. La digitalisation de l'immobilier et l'évolution 
        des technologies de communication ont été bénéfiques, permettant une meilleure compréhension du marché et une adaptation aux
        attentes changeantes des acheteurs, vendeurs et locataires.
      </p>
      <p>Le SMS professionnel est un moyen de communication rapide et efficace pour les agences immobilières, qu'elles se spécialisent 
        dans la transaction de biens ou dans la gestion locative. Avec un excellent rapport qualité-prix, le SMS professionnel est
        l'un des seuls outils capables de concilier des tarifs abordables, une rapidité d'envoi, une mémorisation élevée et une pertinence élevée.</p>
      <h2>
        Dans le domaine de l'immobilier, l'envoi de SMS peut être utile dans différentes situations. 
      </h2>
      
        <li>Campagnes promotionnelles pour mettre en avant des offres spéciales<br /></li>
        <li>Rappels de rendez-vous pour les visites de biens immobiliers<br /></li>
        <li>Rappels d'installations à effectuer ou de paiements à effectuer <br /></li>
        <li>Rappels aux locataires pour le paiement du loyer<br /></li>
        <li>Informer les clients sur de nouvelles propriétés mises en vente<br /></li>
        <li>Faire connaître un nouveau projet immobilier en cours<br /></li>
        <li>Envoi de newsletters via nos SMS enrichis, contenant des liens vers des informations complémentaires</li>
      
      <h2>Quelques exemples de SMS :</h2>
      <div class="cards">
      <div class="card">
        <img class="card__image" src="/../images/immo-1.png">
      </div>
      <div class="card">
        <img class="card__image" src="/../images/immo-2.png">
      </div>
      <div class="card">
        <img class="card__image" src="/../images/immo-3.png">
      </div>
      </div>
    
     
    
    </section>
    <SideNav/>
    </div>
    <Footer/>
  </div>


</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
